<template>
	<div class="imain3">
		<div class="mainbox">
			<div class="ititle wow fadeInUp">{{ t('home.remenjingdian') }}</div>
			<div class="idestination_list">
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoDestination('1')">
						<div class="city name">
							<span class="tconfont tt-earth"></span>
							{{ t('productList.malaixiya') }}
						</div>
						<div class="img"><img :src="getAssetsTopDestinationFile('001/1.jpg')" /></div>
						<div class="tit">
							<div class="t">{{ t('productList.xianbenna') }}</div>
							<div class="m">{{ t('productList.mudidimiaoshu1') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoDestination('2')">
						<div class="city name">
							<span class="tconfont tt-earth"></span>
							{{ t('productList.ruishi') }}
						</div>
						<div class="img"><img :src="getAssetsTopDestinationFile('002/1.jpg')" /></div>
						<div class="tit">
							<div class="t">{{ t('productList.sulishi') }}</div>
							<div class="m">{{ t('productList.mudidimiaoshu2') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoDestination('3')">
						<div class="city name">
							<span class="tconfont tt-earth"></span>
							{{ t('productList.zhongguo') }}
						</div>
						<div class="img"><img :src="getAssetsTopDestinationFile('003/1.jpg')" /></div>
						<div class="tit">
							<div class="t">{{ t('productList.taiwan') }}</div>
							<div class="m">{{ t('productList.mudidimiaoshu3') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoDestination('4')">
						<div class="city name">
							<span class="tconfont tt-earth"></span>
							{{ t('productList.huashengdun') }}
						</div>
						<div class="img"><img :src="getAssetsTopDestinationFile('004/1.jpg')" /></div>
						<div class="tit">
							<div class="t">{{ t('productList.xiyatu') }}</div>
							<div class="m">{{ t('productList.mudidimiaoshu4') }}</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
// import {} from 'vue';
import { useI18n } from 'vue-i18n';
import { routeGo } from '@/hooks/web/jumpGo';
import { getAssetsTopDestinationFile } from '@/utils/getImgUrl';
const { t } = useI18n();
function handleGoDestination(id: string) {
	// if (id === '1') {
	routeGo('destination', id);
	// }
}
</script>

<style lang="scss" scoped></style>
